
import { getEnterprise } from "@/api/enterprise";
import { mapGetters } from "vuex";

export default {
  props: ["mapbox"],
  components: {},
  data() {
    return {
      isDrawer: false,
      hanleActiveName: "1",
      direction: "rtl",
      companyState: "",
      enterActive: "1",
      industry: "",
      nearCompanies: [],
      nearCompaniesLoading: false,
      pagenear: 1,
      total: 0,
      radius: 5,
      lnglat: {},
      switcatch: false,
      showBtn: true,
      currentParams: {
        registration_status: "",
      },
      chain: "",
      qiye: "",
      formattedAddress: "",
      info: {
        layerName: "",
      },
      chart: null,
      morePoints: {
        title: {
          left: "center",
        },
        grid: {
          left: "20px", // 左侧间距
          right: "20px", // 右侧间距
        },
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            return `<div>
                                    <div>${params.data.name}</div>
                                    <div>${params.data.value}家企业</div>
                                    <div>占比：${params.data.per}</div>
                                </div>`;
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: [10, 70],
            center: ["50%", "50%"],
            roseType: "radius",
            itemStyle: {
              borderRadius: 5,
            },
            // label: {
            //   show: true
            // },
            emphasis: {
              label: {
                show: true,
              },
            },
            label: {
              alignTo: "edge",
              // formatter: '{name|{b}}\n{per|{d}}',
              minMargin: 15,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: (params) => {
              const isLeft = params.labelRect.x < this.chart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
            data: [],
          },
        ],
      },
    };
  },
  mounted() {
    const { chainName, companyName, level } = this.$route.query;
    if (chainName && level) {
      this.chain = chainName;
      if (level == 1) {
        this.currentParams.industry_category = chainName;
      } else if (level == 2) {
        this.currentParams.industry_subcategory = chainName;
      }
      this.fetched();
    } else if (companyName && level) {
      this.qiye = companyName;
      if (level == 1) {
        this.currentParams.company_type_category = companyName;
      } else if (level == 2) {
        this.currentParams.company_type_subcategory = companyName;
      }
      this.fetched();
    }
  },
  computed: {
    ...mapGetters(["userInfo", "vip"]),
  },

  methods: {
    deepClone(obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
      return objClone;
    },
    setParkName(formattedAddress) {
      this.formattedAddress = formattedAddress;
    },
    // changeSwitcatch() {
    //     this.$emit('changeSwitch', {isTurf: this.switcatch, radius: this.radius})
    // },
    // handleCommand(command) {
    //     // this.radius = command
    //     this.pagenear = 1
    //     this.toAroundTheCompanies()
    //     // this.$emit('changeSwitch', {isTurf: this.switcatch, radius: this.radius})
    // },
    fetched() {
      this.pagenear = 1;
      this.reflushData();
    },
    changeNear(page) {
      this.pagenear = page;
      this.toAroundTheCompanies({});
    },
    toDetail(code) {
      let router = this.$router.resolve({
        path: `/enterpriseDetail/${code}`,
      });
      window.open(router.href, "_blank");
    },
    closeType() {
      this.industry = "";
      delete this.currentParams.gb_industry_category;
      delete this.currentParams.gb_industry_primary;
      delete this.currentParams.gb_industry_middle;
      $("#root-item1.active").removeClass("active");
      $(".topic-item1.is-active").removeClass("is-active");
      $(".topic-item1.active").removeClass("active");
      this.reflushData();
    },
    closeType1() {
      this.chain = "";
      delete this.currentParams.industry_category;
      delete this.currentParams.industry_subcategory;
      $("#root-item2.active").removeClass("active");
      $(".topic-item2.is-active").removeClass("is-active");
      $(".topic-item2.active").removeClass("active");
      this.reflushData();
    },

    closeType2() {
      this.qiye = "";
      delete this.currentParams.company_type_category;
      delete this.currentParams.company_type_subcategory;
      $("#root-item3.active").removeClass("active");
      $(".topic-item3.is-active").removeClass("is-active");
      $(".topic-item3.active").removeClass("active");
      this.reflushData();
    },

    closeType4() {
      this.info.layerName = "";
      this.info.layer_id = "";
      delete this.currentParams.layer_name;
      delete this.currentParams.layer_id;
      delete this.currentParams.points;
      this.reflushData();
    },

    async reflushData() {
      this.pagenear = 1;
      this.toAroundTheCompanies({});
    },
    countCompanyies(companies) {
      const countMap = companies.reduce((map, item) => {
        const category = item.gb_industry_category;
        map[category] = (map[category] || 0) + 1;
        return map;
      }, {});
      // 计算总次数
      const totalCount = Object.values(countMap).reduce(
        (total, count) => total + count,
        0
      );
      // 构建结果数组
      const result = Object.entries(countMap).map(([category, count]) => ({
        value: count,
        name: category,
        per: `${((count / totalCount) * 100).toFixed(2)}%`,
      }));
      return result;
    },
    handleClickActiveName() {
      if (this.hanleActiveName == 2) {
        this.morePoints.series[0].data = this.countCompanyies(
          this.nearCompanies
        );
        this.chart = echarts.init(
          document.getElementById("chart-container-right")
        );
        this.chart.setOption(this.morePoints);
      }
    },
    // 设置深圳企业的筛选瓦片
    addOrUpdateRasterLayer(layerId = "sz_enterprise", filterOptions = {}) {
      if (Object.keys(filterOptions).length > 0) {
        let layerDefs = "";
        // 遍历 filterOptions 对象的属性
        Object.keys(filterOptions).forEach((key) => {
          const value = filterOptions[key];

          // 只处理非空值的属性
          if (value) {
            // 如果 layerDefs 不为空，添加逻辑运算符 "AND"
            if (layerDefs) {
              layerDefs += " AND ";
            }
            // 拼接属性与值的表达式
            layerDefs += `${key} = '${value}'`;
          }
        });
        let url =
          process.env.NODE_ENV === "dev"
            ? `http://119.29.128.126:6080/arcgis/rest/services/${layerId}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100&layerDefs={0:"${layerDefs}"}`
            : `https://cyy.pcmxj.com/arcgis_server/arcgis/rest/services/${layerId}/MapServer/export?dpi=96&transparent=true&format=png8&layers=&bbox={bbox-epsg-3857}&f=image&bboxSR=102100&imageSR=102100&layerDefs={0:"${layerDefs}"}`;
        // 添加新的源
        if (this.mapbox) {
          const source = this.mapbox.getSource(layerId);
          if (source) {
            this.mapbox.removeLayer(layerId);
            this.mapbox.removeSource(layerId);
          }
          this.mapbox.addSource(layerId, {
            type: "raster",
            tiles: [url],
            tileSize: 256,
          });
          this.mapbox.addLayer({
            id: layerId,
            type: "raster",
            source: layerId,
            "source-layer": layerId,
            layout: {
              visibility: "visible",
            },
            paint: {
              "raster-opacity": 1,
            },
            minzoom: 10,
            maxzoom: 20,
          });
        }
      } else {
        // 添加新的源
        const source = this.mapbox.getSource(layerId);
        if (source) {
          this.mapbox.removeLayer(layerId);
          this.mapbox.removeSource(layerId);
        }
      }
    },
    resetField(params) {
      let par = {};
      if (params.gb_industry_category) {
        par.gb_industr = params.gb_industry_category;
      }

      if (params.gb_industry_primary) {
        par.gb_indus_1 = params.gb_industry_primary;
      }

      if (params.gb_industry_middle) {
        par.gb_indus_2 = params.gb_industry_middle;
      }

      if (params.gb_industry_middle) {
        par.industry_c = params.gb_industry_middle;
      }

      if (params.industry_category) {
        par.industry_c = params.industry_category;
      }

      if (params.industry_subcategory) {
        par.industry_s = params.industry_subcategory;
      }

      if (params.company_type_category) {
        par.company_ty = params.company_type_category;
      }

      if (params.company_type_subcategory) {
        par.company__1 = params.company_type_subcategory;
      }

      if (params.registration_status) {
        par.registrati = params.registration_status;
      }

      return par;
    },
    setListOne(item) {
      this.info.layerName = "";
      this.info.layer_id = "";
      delete this.currentParams.layer_name;
      delete this.currentParams.layerName;
      delete this.currentParams.layer_id;
      delete this.currentParams.points;
      this.nearCompanies = [
        {
          code: item.creditNo,
          company_name: item.name,
          registration_status: item.new_status,
          legal_representative: item.operName,
          establishment_date: item.startDate,
        },
      ];
      this.isDrawer = true;
    },
    async setParkInfo(info) {
      this.info = info;
      if (info.layer_name) {
        delete this.currentParams.points;
        await this.toAroundTheCompanies({
          layer_id: this.info.layer_id,
          layer_name: this.info.layer_name,
        });
      } else if (info.points) {
        delete this.currentParams.layer_name;
        delete this.currentParams.layerName;
        delete this.currentParams.layer_id;
        await this.toAroundTheCompanies({ points: info.points });
      } else {
        delete this.currentParams.layer_name;
        delete this.currentParams.layerName;
        delete this.currentParams.layer_id;
        delete this.currentParams.points;
        await this.reflushData();
      }
    },

    saveAsExcel(buffer, fileName) {
      let data = new Blob([buffer], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(data);
      let link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    exportExcel(data, fileName = "企业名录") {
      if (!this.vip) {
        $("#updrage").click();
        return false;
      }
      if (!this.vip || this.vip.status != "active") {
        $("#updrage").click();
        return false;
      }
      let jsons = data.map((item) => {
        let router = this.$router.resolve({
          path: `/enterpriseDetail/${item.code}`,
        });
        let json = {
          统一社会信用代码: item.code,
          企业名称: item.company_name,
          登记状态: item.registration_status,
          法定代表人: item.legal_representative,
          注册资本: item.registered_capital,
          成立日期: item.establishment_date,
          企业注册地址: item.registered_address,
          电话: item.phone,
          更多电话: item.more_phone,
          邮箱: item.email,
          更多邮箱: item.more_email,
          所属省份: item.province,
          所属城市: item.city,
          所属区县: item.district,
          纳税人识别号: item.taxpayer_identification_number,
          注册号: item.registration_number,
          组织机构代码: item.organization_code,
          参保人数: item.employee_count,
          参保人数所属年报: item.employee_count_annual_report,
          企业机构类型: item.enterprise_type,
          企业规模: item.enterprise_scale,
          核准日期: item.approval_date,
          营业期限: item.business_term,
          国标行业门类: item.gb_industry_category,
          国标行业大类: item.gb_industry_primary,
          国标行业中类: item.gb_industry_middle,
          企业详情: window.location.origin + router.href,
        };
        // json['企业编码'] = item.code
        // json['企业名称'] = item.company_name
        // json['企业状态'] = item.registration_status
        // json['法定代表人'] = item.legal_representative
        // json['成立时间'] = item.establishment_date
        // json['企业联系方式'] = item.phone
        // json['企业注册地址'] = item.registered_address
        // json['企业注册资本'] = item.registered_capital
        // json['国标行业门类'] = item.gb_industry_category
        // json['国标行业大类'] = item.gb_industry_primary
        // json['国标行业中类'] = item.gb_industry_middle
        // json['国标行业中类'] = item.gb_industry_middle

        // json['产业大分类'] = item.industry_category
        // json['产业小分类'] = item.industry_subcategory
        // json['企业性质大分类'] = item.company_type_category
        // json['企业性质小分类'] = item.company_type_subcategory

        // json['企业详情'] = window.location.origin + router.href
        return json;
      });

      let workbook = XLSX.utils.book_new();
      let worksheet = XLSX.utils.json_to_sheet(jsons);
      worksheet["!cols"] = [
        { wch: 20 }, // 第一列宽度为 10 个字符宽
        { wch: 40 }, // 第二列宽度为 20 个字符宽
        { wch: 10 }, // 第三列宽度为 30 个字符宽
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 40 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 50 },
      ];
      // 将工作表添加到工作簿
      // XLSX.utils.sheet_set_column(worksheet, "AA:AA", {
      //     hyperlink: true,
      //     formula: 'HYPERLINK("#"&ADDRESS(ROW(),COLUMN()+1),"企业详情")'
      // });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 将工作簿保存为Excel文件
      let excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcel(excelBuffer, `${fileName}${Date.now()}.xlsx`);
    },
    // 导出excel
    async exportCompanies(info) {
      await this.setParkInfo(info);
      // 创建工作簿和工作表
      this.exportExcel(
        this.nearCompanies,
        (this.info.layerName || "") + " - " + this.formattedAddress
      );
    },
    doExport() {
      this.exportExcel(
        this.nearCompanies,
        (this.info.layerName || "") + " - " + this.formattedAddress
      );
    },
    async exportByDraw(info) {
      await this.setParkInfo(info, false);
      // 创建工作簿和工作表
      this.exportExcel(this.nearCompanies, `红线区域${Data.now()}`);
    },

    // 筛选企业
    async toAroundTheCompanies(params = {}) {
      if (params.points && !Array.isArray(params.points)) {
        return false;
      }
      if (params.company_type_category || params.company_type_subcategory) {
        delete this.currentParams.company_type_category;
        delete this.currentParams.company_type_subcategory;
        this.qiye =
          params.company_type_category || params.company_type_subcategory;
      }

      if (params.industry_category || params.industry_subcategory) {
        delete this.currentParams.industry_category;
        delete this.currentParams.industry_subcategory;
        this.chain = params.industry_category || params.industry_subcategory;
      }

      if (
        params.gb_industry_category ||
        params.gb_industry_primary ||
        params.gb_industry_middle
      ) {
        delete this.currentParams.gb_industry_category;
        delete this.currentParams.gb_industry_primary;
        delete this.currentParams.gb_industry_middle;
        this.industry =
          params.gb_industry_category ||
          params.gb_industry_primary ||
          params.gb_industry_middle;
      }

      this.currentParams = {
        ...this.currentParams,
        ...params,
        page: this.pagenear,
      };

      if (!this.currentParams.registration_status) {
        delete this.currentParams.registration_status;
      }

      let paramsc = this.deepClone(this.currentParams);
      // if ( Object.keys(paramsc).length == 1 && Object.keys(paramsc)[0] == 'page' ) {
      //     return false
      // }
      if (paramsc.layer_name == "zxgh") {
        paramsc.layer_name = "szcsgxlxsj1227";
      }
      if (paramsc.layer_name == "sszt") {
        paramsc.layer_name = "szcsgxlxsj1227";
      }

      if (paramsc.layer_name == "jhlx") {
        paramsc.layer_name = "szcsgxlxsj1227";
      }

      if (paramsc.layer_name == "lytdzbpfgg") {
        paramsc.layer_name = "tdzb";
      }
      if (paramsc.layer_name == "yghcags") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "ygbghtg") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "ynrzbjhjd") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "yghgg") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "ybqbcazxyxynrgs") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "yssfagg") {
        paramsc.layer_name = "tdzb";
      }

      if (paramsc.layer_name == "qt") {
        paramsc.layer_name = "tdzb";
      }

      this.nearCompaniesLoading = true;
      const res = await getEnterprise(paramsc);

      if (res.data) {
        // this.total = res.data.total
        this.nearCompanies = res.data.list;
        this.total =
          res.data.list.length == 1000
            ? res.data.list.length * this.pagenear + 1
            : 1000 * this.pagenear;
      }
      if (
        this.info.layer_id ||
        params.points ||
        this.qiye ||
        this.chain ||
        this.industry
      ) {
        this.$emit("backnearCompanies", this.nearCompanies);
      } else {
        this.$emit("backnearCompanies", []);
      }

      if (this.hanleActiveName == 2) {
        if (this.chart) {
          this.morePoints.series[0].data = this.countCompanyies(
            this.nearCompanies
          );
          this.chart.setOption(this.morePoints);
        }
      }

      this.nearCompaniesLoading = false;
    },

    changeCompanyState() {
      this.currentParams.registration_status = this.companyState;
      this.toAroundTheCompanies({ registration_status: this.companyState });
      this.$emit("changeCompaniesState", this.companyState);
    },
    isShow() {
      return this.isDrawer;
    },
    openMapInfo() {
      this.isDrawer = !this.isDrawer;
      this.$emit("changeDrawerState", this.isDrawer);
    },
    showOnBtn() {
      this.showBtn = true;
    },
    hideOnBtn() {
      this.showBtn = false;
      this.hidePop();
    },
    hidePop() {
      this.isDrawer = false;
    },

    showPop() {
      if (this.showBtn) {
        this.isDrawer = true;
        this.$emit("changeDrawerState", this.isDrawer);
      }
    },
  },
};
